import React from 'react'
import { withAssetPrefix } from 'gatsby'

export default function Image({ src, ...rest }) {
  // this is only to be used for relative paths
  return <img {...rest} src={withAssetPrefix(`/img/${src}`)} />
}
